import React, { useState, useRef } from 'react';
import { NavMenuMobile } from '../NavMenu';
import styled from 'styled-components/macro';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';
import Buscador from '../Buscador';
import CloseIcon from '../svg/close';
import SearchIcon from '../svg/Search';
import { Root, Input, MenuWrapper } from '../Buscador/styles';
import { useTranslate } from '../../contexts/languageContext';

/**
 * Navegador entre ámbitos para la versión móvil (responsive) del sitio web.
 * Incluye a **Buscador** para buscar entre ámbitos y una serie de drodowns que se revelan
 * según se utiliza el anterior para acceder a ámbitos de disinto nivel.
 */
const BuscadorMobile = ({ nomenclator, eleccion, ambito, page, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFullH, setIsFullH] = useState(false);
  const closeRef = useRef();
  return (
    <BuscadorModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      initialFocusRef={closeRef}
			setIsFullH={setIsFullH}
      icon={
        <SearchIcon
          fill="#fff"
          css={`
            vertical-align: top;
          `}
        />
      }
      className={className}
    >
      <CloseRow>
        <StyledBuscador
          eleccion={eleccion}
          nomenclator={nomenclator}
          page={page}
          onSelect={() => {setIsOpen(false); setIsFullH(false)}}
          searchIconColor="#283f5f"
        />
        <CloseButton onClick={() => {setIsOpen(false); setIsFullH(false)}} ref={closeRef}>
          <CloseIcon
            width={30}
            height={30}
            fill="#ffffff"
            css={`
              vertical-align: top;
            `}
          />
        </CloseButton>
      </CloseRow>
      <StyledNavMenuMobile
        nomenclator={nomenclator}
        eleccion={eleccion}
        ambito={ambito}
        page={page}
        setIsOpen={setIsOpen}
				isFullH={isFullH}
      />
    </BuscadorModal>
  );
};

const BuscadorModal = ({
  className,
  children,
  isOpen,
  setIsOpen,
  icon,
  initialFocusRef,
	setIsFullH
}) => {
  const t = useTranslate();
  return (
    <Container className={className}>
      <OpenButton onClick={() => {
					setIsFullH(true)
					setIsOpen(true)
				}}>
        {icon}
        <span className="visually-hidden">
          {t('abrirMenuNavegacionPorAmbitos')}
        </span>
      </OpenButton>
      {isOpen && (
        <StyledDialogOverlay
          initialFocusRef={initialFocusRef}
          onDismiss={() => setIsOpen(false)}
          isOpen={isOpen}
        >
          <StyledDialogContent>{children}</StyledDialogContent>
        </StyledDialogOverlay>
      )}
    </Container>
  );
};

const CloseRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const StyledDialogOverlay = styled(DialogOverlay)`
  && {
    background-color: white;
    z-index: 10000;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 1;
    width: 100%;
    display: flex;
    flex-flow: column;
    background-color: white;
    & .focus-visible {
      outline: 2px solid black;
      outline-offset: -2px;
    }
  }
`;

const CloseButton = styled.button`
  background: #283f5f;
  border: none;
  padding: 10px;
  justify-self: flex-end;
`;

const OpenButton = styled.button`
  width: 100%;
  height: 100%;
  background: #1C283D;
  border: none;
  & .focus-visible {
    outline: 2px solid black;
    outline-offset: -2px;
  }
`;

const StyledBuscador = styled(Buscador)`
  width: 100%;
  ${Root} {
    width: 100%;
  }
  ${Input} {
    background: rgb(225, 225, 221, 0.3);
    ::placeholder {
      color: #222;
    }
    color: #222;
  }
  & .focus-visible {
    outline: none;
  }

  ${MenuWrapper} {
    width: 100%;
    border-radius: 0 0 5px 5px;
    background: white;
  }
`;

const StyledNavMenuMobile = styled(NavMenuMobile)``;
export default BuscadorMobile;
